<div class="confirm-dialog__head">
  <h2 mat-dialog-title class="confirm-dialog__title">{{ data.title }}</h2>
  <button
    mat-icon-button
    type="button"
    class="confirm-dialog__close"
    aria-label="Close"
    (click)="dismiss()"
  >
    <app-icon name="x" [size]="18" />
  </button>
</div>
<mat-dialog-content>
  <p class="confirm-dialog__message">{{ data.message }}</p>
  @if (error(); as message) {
    <div class="error-banner confirm-dialog__error" role="alert">{{ message }}</div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="dismiss()">
    {{ data.cancelLabel ?? 'Cancel' }}
  </button>
  <button
    mat-flat-button
    type="button"
    [class.confirm-dialog__confirm--destructive]="data.destructive"
    [disabled]="pending()"
    (click)="confirm()"
    cdkFocusInitial
  >
    @if (pending()) {
      <mat-spinner diameter="20" />
    } @else {
      {{ data.confirmLabel }}
    }
  </button>
</mat-dialog-actions>
